import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import * as Styled from './StyledSessions';

function RightSession(props) {
    const { data } = props;
    const dataChart = data.contractsWithStartupsChartData;
    // eslint-disable-next-line no-useless-computed-key
    const formattedDataChart = dataChart.map(item => {
        return {
            _id: item._id,
            date: item.date,
            contract: item.contracts,
            // eslint-disable-next-line no-useless-computed-key
            ['categoria A']: item.catA,
            // eslint-disable-next-line no-useless-computed-key
            ['categoria B']: item.catB,
            // eslint-disable-next-line no-useless-computed-key
            ['categoria C']: item.catC,
            // eslint-disable-next-line no-useless-computed-key
            ['categoria D']: item.catD,
        };
    });

    return (
        <Styled.RightSession>
            <Styled.UpperContainer>
                <Styled.UpperTitle>
                    <h1>{data.contractsWithStartupsTotal}</h1>
                    <h2>contrato(s) com startups</h2>
                </Styled.UpperTitle>

                <Styled.RSGraphicsContainer>
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart
                            width={'100%'}
                            height={'100%'}
                            data={formattedDataChart}
                            margin={{
                                top: 10,
                                right: 40,
                                left: -20,
                                bottom: 0,
                            }}
                        >
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Area
                                type="monotone"
                                dataKey="categoria A"
                                stackId="1"
                                stroke="#103a70"
                                fill="#0088FE"
                            />
                            <Area
                                type="monotone"
                                dataKey="categoria B"
                                stackId="2"
                                stroke="#178773"
                                fill="#00C49F"
                            />
                            <Area
                                type="monotone"
                                dataKey="categoria C"
                                stackId="3"
                                stroke="#a17518"
                                fill="#FFBB28"
                            />
                            <Area
                                type="monotone"
                                dataKey="categoria D"
                                stackId="4"
                                stroke="#9f5029"
                                fill="#FF8042"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </Styled.RSGraphicsContainer>
            </Styled.UpperContainer>
            <Styled.LowerContainer>
                <h2>Novas Startups Contratadas</h2>
                <Styled.NewStartupsLogosContainer>
                    {data.latestContractedStartups.slice(0, 10).map(startup => {
                        return (
                            <Styled.NewStartupsIndividualLogo key={startup.logoUrl}>
                                <img src={startup.logoUrl} alt={startup.name} />
                            </Styled.NewStartupsIndividualLogo>
                        );
                    })}
                </Styled.NewStartupsLogosContainer>
            </Styled.LowerContainer>
        </Styled.RightSession>
    );
}

export default RightSession;
